import React, { useRef, useState } from 'react';
import { ExtensionForm } from '../components/genericEntity/entity/ExtensionForm';
import { genericEntityService } from '../services/genericEntityService';
import { v4 as uuidv4 } from 'uuid';
import { Box, Button, TextField, Typography, Paper, Alert, Stack } from '@mui/material';

export default function ExtensionFormDemo() {
    const extensionFormRef = useRef();
    const [guid, setGuid] = useState('');
    const [tableName, setTableName] = useState('booking');
    const [message, setMessage] = useState('');

    const handleSave = () => {
        if (!extensionFormRef.current?.canSave()) {
            setMessage('❌ Preencha todos os campos obrigatórios!');
            return;
        }

        // Gerar GUID se não existir
        const extendedEntityId = guid || uuidv4();
        
        if (!guid) {
            // CREATE - novo item
            extensionFormRef.current.handleCreate(extendedEntityId);
            setGuid(extendedEntityId);
            setMessage(`✅ Criado com sucesso! GUID: ${extendedEntityId}`);
        } else {
            // UPDATE - item existente
            extensionFormRef.current.handleSave();
            setMessage('✅ Atualizado com sucesso!');
        }
    };

    const handleDelete = () => {
        if (!guid) {
            setMessage('❌ Nenhum GUID selecionado para excluir!');
            return;
        }

        if (window.confirm(`Tem certeza que deseja excluir a extensão do ${tableName} com GUID:\n${guid}?`)) {
            genericEntityService.deleteExtensionItem(tableName, guid)
                .then(() => {
                    setMessage(`✅ Extensão excluída com sucesso!`);
                    handleNew();
                })
                .catch((error) => {
                    setMessage('❌ Erro ao excluir: ' + (error?.response?.data?.message || error.message));
                });
        }
    };

    const handleNew = () => {
        setGuid('');
        setTableName('booking');
        setMessage('');
    };

    return (
        <Box sx={{ p: 3, maxWidth: 1000, margin: '0 auto' }}>
            <Typography variant="h4" gutterBottom>
                 ExtensionForm - Teste
            </Typography>

            {message && (
                <Alert 
                    severity={message.includes('❌') ? 'error' : message.includes('📂') ? 'info' : 'success'} 
                    sx={{ mb: 3 }}
                    onClose={() => setMessage('')}
                >
                    {message}
                </Alert>
            )}

            <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
                <Typography variant="h6" gutterBottom>
                    ⚙️ Configuração
                </Typography>
                <Stack spacing={2} sx={{ mb: 3 }}>
                    <TextField
                        label="Nome da Tabela"
                        value={tableName}tableName
                        onChange={(e) => setTableName(e.target.value)}
                        placeholder="booking"
                        fullWidth
                        helperText="Nome da entidade configurada (ex: booking, BL, Vessel)"
                    />
                    <TextField
                        label="GUID de Booking"
                        value={guid}
                        onChange={(e) => setGuid(e.target.value)}
                        placeholder="Deixe vazio para criar novo (auto-gerar)"
                        fullWidth
                        helperText="GUID que vincula ao booking, será carregado automaticamente quando entrar num booking existente"
                    />
                </Stack>
            </Paper>

            <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
                <Typography variant="h6" gutterBottom>
                     Campos Dinâmicos ({tableName})
                </Typography>
                <Typography variant="h7" gutterBottom>
                    Estes campos sao criados do lado de GE ({tableName})
                </Typography>
                
                <ExtensionForm
                    ref={extensionFormRef}
                    extendedEntityId={tableName}
                    extendedItemId={guid || null}
                    canEdit={true}
                    handleErrorCallback={(error) => {
                        console.error('Erro:', error);
                        setMessage('❌ Erro: ' + (error?.response?.data?.message || error.message));
                    }}
                />
            </Paper>

            <Paper elevation={3} sx={{ p: 3 }}>
                <Stack direction="row" spacing={2}>
                    <Button 
                        variant="contained" 
                        color="success"
                        size="large"
                        onClick={handleSave}
                    >
                        💾 Salvar
                    </Button>
                    
                    <Button 
                        variant="contained" 
                        color="error"
                        size="large"
                        onClick={handleDelete}
                        disabled={!guid}
                    >
                        🗑️ Excluir
                    </Button>
                    
                    <Button 
                        variant="outlined" 
                        color="secondary"
                        size="large"
                        onClick={handleNew}
                    >
                        ➕ Limpar
                    </Button>
                </Stack>

                {guid && (
                    <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
                        <Typography variant="caption" display="block">
                            <strong>GUID atual:</strong> {guid}
                        </Typography>
                        <Typography variant="caption" display="block">
                            <strong>Modo:</strong> {guid ? 'UPDATE' : 'CREATE'}
                        </Typography>
                        <Typography variant="caption" display="block" sx={{ mt: 1, color: 'error.main' }}>
                            ⚠️ <strong>Excluir:</strong> Remove apenas os dados de extensão. O registro em {tableName} não é afetado.
                        </Typography>
                    </Box>
                )}
            </Paper>
        </Box>
    );
}
